/* import __COLOCATED_TEMPLATE__ from './reviewable-topic-link.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./reviewable-topic-link.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));